import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../../common/dropdown'
import useDidUpdateEffect from '../../../../../common/hooks/useDidUpdateEffect'
import { Button } from '../../../../../common/html/button'
import { Element } from '../../../../../common/html/element'
import { InputTextArea } from '../../../../../common/html/input/InputTextArea'
import { Image } from '../../../../../common/image'
import { Tooltip } from '../../../../../common/tooltip'
import classes from '../../../../index.module.scss'
import {
  changeListValidVolume,
  selectBuyPackage,
  selectKeyCheckValidVolume,
  setListPackage,
} from '../../../store/slice'
import infoVolume from '../../icon/infoVolume.svg'

const VOLUME_BUTTONS = [10, 30, 50, 100, 200, 300, 500, 1000]

export const VolumeInputArea = ({ itemIndex }) => {
  const dispatch = useDispatch()

  const [isValid, setValid] = useState(true)

  const buyPackage = useSelector(selectBuyPackage)
  const keyCheckValidVolume = useSelector(selectKeyCheckValidVolume)

  const listPackage = buyPackage?.listPackage

  const inputValue = listPackage[itemIndex]?.volume || ''

  const setInputValue = (inputValue) => {
    const newListPackage = listPackage.map((item, index) =>
      index === itemIndex
        ? {
            ...item,
            volume: Number(inputValue),
          }
        : { ...item },
    )
    dispatch(setListPackage(newListPackage))
  }

  useDidUpdateEffect(() => {
    dispatch(
      changeListValidVolume({
        [itemIndex]: !!listPackage[itemIndex]?.volume,
      }),
    )
    setValid(!!listPackage[itemIndex]?.volume)
  }, [keyCheckValidVolume])

  useEffect(() => {
    dispatch(
      changeListValidVolume({
        [itemIndex]: true,
      }),
    )
    setValid(true)
  }, [inputValue])

  const suggestionButtons = (
    <div className="flexRow">
      {VOLUME_BUTTONS.map((item, index) => (
        <Button
          key={index}
          label={item?.toString()}
          style={{
            border: '1px solid #E0E0E0',
            backgroundColor: '#FFFFFF',
            padding: 4,
            borderRadius: '4px',
            marginLeft: 4,
            fontSize: 11,
            cursor: 'pointer',
          }}
          action={() => setInputValue(item?.toString())}
          isI18n
        />
      ))}
    </div>
  )

  return (
    <>
      <div className={[classes.fieldRow, 'flexRow flexStart'].join(' ')}>
        <Element
          className={[classes.firstTwoTitle, 'flexRow'].join(' ')}
          style={{ marginTop: 5 }}
        >
          <Element className="fw600">
            <Translate value="userManagement.buyPackage.VOLUME" />
          </Element>
          <Tooltip
            tooltipContent="userManagement.buyPackage.VOLUME_TOOLTIP"
            isI18n
            position={positionDropdown.TOP_CENTER}
            zIndex={9999}
          >
            <Image
              src={infoVolume}
              alt="infoVolume"
              style={{
                width: 13,
                height: 13,
                marginLeft: 6,
              }}
            />
          </Tooltip>
        </Element>
        <InputTextArea
          isShowLabel={false}
          placeHolder="userManagement.buyPackage.INSERT_VOLUME"
          containerStyle={{
            width: 300,
            height: 70,
            marginBottom: isValid ? 0 : 10,
          }}
          style={{ resize: 'none' }}
          value={inputValue || ''}
          suggestionBtns={suggestionButtons}
          onChange={(e) => setInputValue(e.target.value)}
          isValid={isValid}
          textInvalid="userManagement.buyPackage.TEXT_INVALID_VOLUME"
        />
      </div>
    </>
  )
}
